import { Icon, IconProps } from '../Icon'

export const CopyIcon = ({ size, color }: IconProps) => {
  return (
    <Icon color={color} size={size}>
      content_copy
    </Icon>
  )
}
